import { createFileRoute, redirect } from '@tanstack/react-router';

/** Redirects to the complete notification list on the home page. */
export const Route = createFileRoute('/_app/_platform/notifications')({
    beforeLoad: () => {
        throw redirect({ to: '/', search: { notifications: 1 }, replace: true });
    },
});
